<template>
  <div v-if="!tokenExpire">
    <div
      class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
    >
      <div class="flex flex-row items-end">
        <div
          class="bg-theme-9 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
        >
          GR
        </div>
        <h2 class="text-lg font-medium ml-4">รายละเอียด {{ gr.gr_no }}</h2>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
      <div class="intro-y col-span-12">
        <div class="mt-5">
          <div class="h-10 w-full text-center my-20" v-if="loadingPage">
            <LoadingIcon icon="oval" class="w-12 h-12" />
          </div>
          <div class="horizontal-form" v-else>
            <div class="mb-4" v-if="isApprove">
              <ApproveGR
                :gr-id="gr.gr_id"
                :activity="gr.activity_list"
                :employee-id="gr.claim_id"
                :show="gr.is_approve_token_used == 0"
                :edit="gr.flag_edit == 1"
                :approver-info="gr.approver_info"
                :token="token"
                @reload="reloadGR"
              />
            </div>
            <div class="mb-4">
              <DocumentPath
                :document-path="gr.document_path_array"
                :status-code="gr.status_code"
                :flag-edit="gr.flag_edit"
                :next-status-code="gr.next_status"
                :approve-result="gr.approve_result_array"
              />
            </div>
            <HeaderCompany
              :img-logo="gr.gr_comp.comp_logo"
              :status-name="gr.status_name"
              :participants="gr.participants"
              :document-path="gr.document_path_text_array"
            />
            <div class="mt-5">
              <TableSummaryCost
                :items="gr.itemSummary"
                :is-permission-vat="gr.is_permission_vat"
                :is-approve="isApprove"
                :is-claim="isClaim"
              />
            </div>
            <div class="box intro-y mt-5 p-5">
              <HeaderOwner
                :reqName="gr.req_name"
                :companyName="gr.gr_comp.comp_name_th"
                :buNo="gr.bu_no"
                :buName="gr.bu_name"
                :telephone="gr.telephone"
              />
            </div>
            <div class="grid grid-cols-1 lg:grid-cols-3 mt-5 lg:gap-4">
              <!-- ข้อมูลการขอซื้อ -->
              <DetailGR
                class="intro-y col-span-2 box p-5"
                :poDocNoFull="gr.poDocNoFull"
                :poDocTypeText="po.poDocTypeText"
                :reasonChosenVendor="po.reasonChosenVendor"
                :currency="po.currency"
                :orderTypeText="po.orderTypeText"
                :discountAllItem="po.discountAllItem"
                :reqDetail="po.req_detail"
                :vendor="po.vendor"
                :memo="po.ememo"
                :fileAttachArray="po.file_attach_array"
                :importantFactor="po.importantFactor"
              />
              <DetailShipping
                class="intro-y box p-5 lg:space-y-4 order-last mt-5 lg:mt-0"
                :shipping="po.shipping"
              />
            </div>

            <!-- รายละเอียดการตรวจรับ -->
            <div class="intry-y box p-5 mt-5">
              <DetailReceive
                :id="gr.gr_id"
                :vendor="gr.vendor"
                :prDocNoFull="po.prDocNoFull"
                :poDocNoFull="gr.poDocNoFull"
                :invoice="gr.invoice"
                :reqDate="gr.reqDate"
                :reqDetail="gr.req_detail"
                :instalment="gr.instalment"
                :glDate="gr.glDate"
                :fileAttachArray="gr.file_attach_array"
                :isPermissionVat="gr.is_permission_vat"
                :isApprove="isApprove"
                :isClaim="isClaim"
              />
            </div>

            <div class="mt-5 gap-4">
              <div class="intro-y box p-5 space-y-4">
                <div class="text-lg font-bold">รายการเบิก</div>
                <TableItemGR
                  :items="gr.items"
                  :is-permission-vat="gr.is_permission_vat"
                  :is-approve="isApprove"
                  :is-claim="isClaim"
                  :analysis-code-option="analysisCodeOption"
                />
              </div>
            </div>
            <div class="mt-5">
              <TableHistory :items="gr.historyArray" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <TryLogin :tokenExpireText="tokenExpireText" />
  </div>
  <Notification />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  reactive,
  onMounted,
  ref,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute } from 'vue-router'
import { api } from '../../../utils/api'
import alert from '../../../helpers/alert'
import helpers from '../../../helpers'
import ApproveGR from '@/components/approve-gr/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import TableItemGR from '@/components/TableItemGR.vue'
import Notification from '@/components/notification/Notification.vue'
import TryLogin from '@/components/TryLogin.vue'
import HeaderCompany from '@/components/HeaderCompany.vue'
import HeaderOwner from '@/components/HeaderOwner.vue'
import DetailGR from './DetailGR.vue'
import DetailShipping from '@/components/DetailShipping.vue'
import DetailReceive from './DetailReceive.vue'

export default defineComponent({
  components: {
    ApproveGR,
    DocumentPath,
    TableSummaryCost,
    TableHistory,
    TableItemGR,
    Notification,
    TryLogin,
    HeaderCompany,
    HeaderOwner,
    DetailGR,
    DetailShipping,
    DetailReceive
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    // const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const analysisCodeOption = computed(() => store.state.global.analysisCode)
    // const btnReject = computed(() => store.state.gr.btnReject)

    // const userInfo = computed(() => store.state.auth.info)
    const { numberFormat } = helpers

    const tokenExpire = ref(false)
    const tokenExpireText = ref('')
    const token = ref(route.query.token)
    const isOwner = ref(false)
    const isApprove = ref(false)

    const gr = reactive({
      owner_name: '',
      gr_no: '',
      status_code: null,
      next_status: null,
      gr_id: null,
      po_id: null,
      claim_id: '',
      glDate: '',
      activity_list: [],
      document_path_text_array: [],
      document_path_array: [],
      approve_result_array: [],
      gr_comp: {
        comp_name_th: '',
        comp_logo: ''
      },
      telephone: '',
      bu_no: '',
      bu_name: '',
      currency: '',
      req_name: '',
      req_detail: '',
      flag_edit: 0,
      file_attach_array: [],
      items: [],
      itemSummary: [],
      historyArray: [],
      is_approve_token_used: 0,
      status_name: '',
      participants: '',
      prDocNoFull: '',
      poDocNoFull: '',
      invoice: {
        no: '',
        date: ''
      },
      reqDate: '',
      instalment: {
        type: '',
        typeText: '',
        no: ''
      },
      vendor: {
        code: '',
        name: ''
      },
      is_permission_vat: false,
      approver_info: {}
    })

    const po = reactive({
      prDocNoFull: '',
      req_detail: '',
      currency: '',
      file_attach_array: [],
      orderTypeText: '',
      discountAllItem: 0,
      poDocTypeText: '',
      reasonChosenVendor: '',

      vendor: {
        code: '',
        name: '',
        email: '',
        address: '',
        telephone: ''
      },
      shipping: {
        date: '',
        address: '',
        recipient: '',
        conditionSend: '',
        conditionPayment: '',
        checkBy: ''
      },
      ememo: {
        id: null,
        title: '',
        link: null
      },
      importantFactor: ''
    })

    const reloadGR = () => {
      loadGR()
    }

    const isClaim = computed(() => store.state.gr.isClaim)

    const loadGR = async () => {
      if (route.query.token) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/procurement/gr/getByToken/${route.query.token}`
          )
          .then(res => {
            if (res.code == 200) {
              gr.gr_id = res.data.gr_id
              gr.po_id = res.data.po_id
              gr.activity_list = res.data.allow_list_array
                ? res.data.allow_list_array.activity_list
                : []
              gr.owner_name = res.data.owner_name
              gr.gr_no = res.data.doc_no_full
              gr.claim_id = res.data.claim_id
              gr.is_approve_token_used = res.data.is_approve_token_used
              gr.status_code = res.data.status_code
              gr.next_status = res.data.next_status
              gr.document_path_text_array = res.data.document_path_text_array
              gr.document_path_array = res.data.document_path_array
              gr.approve_result_array = res.data.approve_result_array
              gr.req_name = res.data.req_name
              gr.telephone = res.data.telephone
              gr.bu_no = res.data.bu_no
              gr.bu_name = res.data.bu_name
              gr.req_detail = res.data.req_detail
              gr.flag_edit = res.data.flag_edit
              gr.status_name = res.data.status_name
              gr.participants = res.data.participants
              gr.itemSummary = res.data.itemSummary
              gr.historyArray = res.data.history_array
              gr.file_attach_array = res.data.file_attach_array
              gr.prDocNoFull = res.data.po_info.pr_doc_no_full
              gr.poDocNoFull = res.data.po_info.doc_no_full

              gr.approver_info = res.data.approver_info

              gr.invoice.no = res.data.invoice_no
              gr.invoice.date = res.data.invoice_date
              gr.reqDate = res.data.req_date
              gr.glDate = res.data.gl_date
              gr.instalment.no = res.data.instalment_no
              gr.instalment.type = res.data.instalment_type
              gr.instalment.typeText = store.getters[
                'gr/getInstalmentTypeText'
              ](res.data.instalment_type)

              gr.items = res.data.items.map(item => {
                item.taxVatProcess = item.vat > 0
                item.taxWhProcess = item.wh_tax > 0
                item.retentionProcess = item.retention > 0
                return item
              })

              gr.vendor.code = res.data.vendor_code
              gr.vendor.name = res.data.vendor_name
              gr.is_permission_vat = res.data.is_permission_vat != 0

              po.req_detail = res.data.po_info.req_detail
              po.currency = res.data.po_info.currency_code
              po.orderTypeText = res.data.po_info.order_type_text
              po.discountAllItem = res.data.po_info.discount_all_item
              po.vendor.code = res.data.po_info.vendor_code
              po.vendor.name = res.data.po_info.vendor_name
              po.vendor.email = res.data.po_info.vendor_email
              po.vendor.telephone = res.data.po_info.vendor_telephone

              po.prDocNoFull = res.data.po_info.pr_doc_no_full
              po.poDocTypeText = res.data.po_info.po_doc_type_text
              po.reasonChosenVendor = res.data.po_info.reason_chosen_vendor

              po.shipping.address = res.data.po_info.shipping_address
              po.shipping.recipient = res.data.po_info.shipping_recipient
              po.shipping.conditionSend =
                res.data.po_info.shipping_condition_send
              po.shipping.conditionPayment = res.data.po_info.payment_term_name
              po.shipping.checkBy = res.data.po_info.shipping_check_by
              po.shipping.date = res.data.po_info.shipping_date

              po.importantFactor = res.data.po_info.important_factor

              if (
                res.data.po_info.ememo_id != 0 &&
                res.data.po_info.ememo_id != null
              ) {
                po.ememo.id = res.data.po_info.ememo_id
                po.ememo.title = res.data.po_info.ememo_title
                po.ememo.link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${res.data.po_info.ememo_id}/detail`
              }
              po.file_attach_array = res.data.po_info.file_attach_array

              gr.gr_comp = store.getters['global/companyFind'](res.data.gr_comp)
              isApprove.value = false
              if (res.data.allow_list_array && res.data.approver_info) {
                res.data.allow_list_array.activity_list.map(item => {
                  // if (item.employee_id == res.data.claim_id) {
                  if (item.employee_id == res.data.approver_info.employee_id) {
                    isApprove.value = true
                  }
                })
                // if (res.data.claim_id === null) {
                //   isApprove.value = true
                // }
              }

              store.commit(
                'gr/setIsClaim',
                res.data.claim_id === null && isApprove.value
              )

              store.commit('global/setOverBudget', {
                message:
                  res.data.is_over_budget == 1
                    ? 'เกินงบประมาณ'
                    : 'อยู่ในงบประมาณ',
                isOver: res.data.is_over_budget == 1,
                show: true
              })
            } else {
              tokenExpire.value = true
              tokenExpireText.value = res.validator.approve_token[0]
            }
          })
          .catch(e => {
            alert.error(e.message)
            // console.log('error: ', e)
            tokenExpire.value = true
          })
      }
    }

    onUnmounted(() => {
      console.log('unmounted page gr approve')
      store.commit('gr/initBtn')
      isOwner.value = false
      isApprove.value = false
    })

    onMounted(async () => {
      console.log('mounted page gr approve')
      await store.dispatch('global/loadCompanyToken')
      await store.dispatch('global/loadCash')
      store.dispatch('gr/loadGrOptionInstalmentType')
      await loadGR()
      store.commit('global/setLoadingPage', false)
    })

    return {
      gr,
      po,
      reloadGR,
      loadingPage,
      numberFormat,
      tokenExpire,
      tokenExpireText,
      token,
      isOwner,
      isApprove,
      isClaim,
      analysisCodeOption
    }
  }
})
</script>
